export default __webpack_public_path__ + "static/favicon2-85aadaca041e149056243a1ae5a2de20.ico";